import { DataBean } from "../DataBean";

export class AdquisitionItemBudgetID extends DataBean {

    public async getAdquisitionItemBudgetIDCatalog(idAdquisitionItem: number): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getAdquisitionItemBudgetIDCatalog_Number", [idAdquisitionItem]);
    }

}